<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading">
    Loading
  </a-card>
  <div v-else>
    <div
      :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'"
      v-if="pageLoading === false"
    >
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              PP Claim Manifest
              <small class="m-display-block m-text-small">{{
                data.header ? data.header.no_klaim : null
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrint"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    >Claim PP Report</a-button
                  >
                </li>
                  <li v-if="data.iskomisi &&
                  getAuth.username != data.user_pembuat.tlc">
                  <a-button
                    @click="handlePrintKomisi"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifestkomisi"
                    >Commision Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi &&
                  getAuth.username != data.user_pembuat.tlc">
                  <a-button
                    type="dashed"
                    icon="printer"
                    block
                    :loading="printLoad.manifestfiktif"
                    @click="handlePrintFiktif"
                    class="m-display-block"
                    >Fictitious Name Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi">
                  <a-button
                    type="dashed"
                    icon="printer"
                    block
                    :loading="printLoad.manifestWtNote"
                    @click="handlePrintWtNote"
                    class="m-display-block"
                    >Approval Commision Report</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.user_pembuat.tlc">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.user_pembuat.tlc
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.user_pembuat.tlc
                        )
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>No PP</span>
                  <span class="m-list-desc">{{ data.header.no_pp }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.tanggal_buat).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User</span>
                  <span class="m-list-desc">{{
                    data.header.user_pelapor
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Cost Center</span>
                  <span class="m-list-desc">{{
                    data.header.kode_project
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total amount of use</span>
                  <span class="m-list-desc">{{
                    formatCurrency(currency,data.header.total_klaim)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{
                    data.header.catatan ? data.header.catatan : '-'
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse v-if="getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-list
                itemLayout="vertical"
                :dataSource="data.detail_invoice"
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <span slot="title">{{
                      item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                    }}</span>
                    <div slot="description" class="margin-remove">
                      <span>{{
                        moment(item.tanggal).format(getDefaultDateFormat)
                      }}</span>
                      <div>
                        <span>{{ item.label }}</span>
                        <h4 class="margin-remove">
                          {{ formatCurrency(currency,item.nilai) }}
                        </h4>
                      </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Total Amount of Use</h4>
              <a-card :loading="pageLoading">
                <ul class="m-list-wrapper">
                  <li>
                    <a-input-search
                      v-model="search"
                      style="width: 50%"
                      placeholder="Quick Search"
                      allowClear
                      :change="searching"
                    />
                  </li>
                </ul>
              </a-card>
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                :scroll="{ x: 800 }"
                bordered
              >
                <span slot="deskripsi" slot-scope="item">
                  {{item.deskripsi}}
                </span>
                <template slot="document" slot-scope="index, item">
                  <a-button-group v-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                    <a-button type="primary" icon="edit" @click="handleUploadDoc(item)" :loading="uploadDoc.loading2 && uploadDoc.loading2key == item.id_dtl"></a-button>
                    <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                    <a-button type="default" disabled v-else>No File</a-button>
                  </a-button-group>
                  <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" class="margin-top">
                    View Document
                  </a>
                  <div v-else class="margin-top">
                    :: No File Uploaded ::
                  </div>
                </template>
                <span slot="item_anggaran" slot-scope="item">
                  <b>{{item.item_anggaran}}</b><br/>
                  <p>{{item.kode_anggaran}}</p>
                </span>
                <span slot="kredit" slot-scope="kredit">
                  <CurrencyJustified
                    v-if="kredit.val"
                    :currencyValue="kredit.curr"
                    :valueNumber="kredit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>

                <span slot="doc_tax" slot-scope="item">
                  <div style="text-align: center;">
                    <a-button icon="edit" size="small"
                      :type="item.tax_verif !== '0' ? 'primary' : 'danger'"
                      style="margin-right:5px" @click="handleShowTaxModal(item)"
                      :disabled="data.jenis !== 'Verifikator' || item.id_dtl == null && item.id_hdr == null"
                      >
                    </a-button>
                  </div>
                </span>

                <template slot="footer">
                  <a-row type="flex">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Total Credit</a-col
                    >
                    <a-col
                      :span="5"
                      :order="2"
                      class="m-text-align left m-text-bold"
                      >{{ formatCurrency(currency,data.header.total_klaim) }}</a-col
                    >
                  </a-row>
                </template>
              </a-table>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="margin-top"
            :loading="pageLoading"
            v-if="
              data.jenis.toLowerCase() !== 'manifest' &&
              data.jenis.toLowerCase() !== 'transfer'
            "
          >
          <div slot="title">Manifest Actions
            &nbsp;<i v-if="data.jenis=='Transfer' && !data.status_transfer" style="color:red!important">(Funding has not been set)</i>
          </div>
          <div slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(currency,data.sisa_tf)
              }}</a-tag>
            </div>
          <template v-if="!(data.jenis=='Transfer' && !data.status_transfer)">
            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                  showSearch
                  v-decorator="[
                    'aksi',
                    {
                      rules: [{ required: true }],
                      defaultValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
            <template class="ant-card-actions" slot="actions">
              <a-button
                :loading="saveLoading"
                @click="handleAction"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </template>
          </template>
          </a-card>
          <a-card
            class="margin-top"
            :loading="pageLoading"
            v-if="data.jenis.toLowerCase() === 'transfer'"
          >
            <div slot="title">Manifest Actions
              &nbsp;<i v-if="data.jenis=='Transfer' && !data.status_transfer" style="color:red!important">(Funding has not been set)</i>
            </div>
            <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  remaining balance
                </h5>
                <a-tag color="green" class="m-text-align right margin-remove">{{
                  formatCurrency(currency,data.sisa_tf)
                }}</a-tag>
              </div>
            <template v-if="!(data.jenis=='Transfer' && !data.status_transfer)">
              <a-form :form="form">
                <a-form-item label="Aksi">
                  <a-select
                    @change="handleAksi"
                    showSearch
                    v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item v-if="!isRevised" label="Transfer Date">
                  <a-date-picker
                    placeholder="Select Date"
                    :format="getDefaultDateFormat"
                    v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                  />
                </a-form-item>
                <a-form-item label="Evidence of transfer" v-if="!isRevised">
                  <a-upload
                    accept="image/*"
                    :showUploadList="true"
                    :remove="removeFileList"
                    :fileList="push"
                    listType="picture"
                    :beforeUpload="beforeUpload"
                    v-decorator="[
                      'upload',
                      { rules: [{ required: true }] },
                      { valuePropName: 'push' },
                    ]"
                  >
                    <a-button>
                      <a-icon type="upload" />&nbsp;Select your file
                    </a-button>
                  </a-upload>
                </a-form-item>
                <a-form-item label="Transfer Value" v-if="!isRevised">
                  <a-input-number
                    :disabled="disabled"
                    type="number"
                    :max="data.sisa_tf"
                    class="m-width-full m-text-align right"
                    :formatter="
                      (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    v-decorator="[
                      'value_transferan',
                      { rules: [{ required: true }], initialValue: data.sisa_tf },
                    ]"
                  />
                </a-form-item>
                <a-checkbox
                  class="margin-bottom"
                  @change="handleCheckData"
                  :checked="checkTransferValue"
                  v-if="!isRevised"
                  >The transferred value matches of the remaining
                  balance</a-checkbox
                >
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['remark']"
                  />
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  :loading="saveLoading"
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </template>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">Transfer Receipt</div>
            <div>
              <a-alert
                v-if="data.bukti_transfer.length <= 0"
                type="error"
                message="No evidence of transfer was uploaded!"
                banner
              />
              <a-list
                itemLayout="horizontal"
                :dataSource="data.bukti_transfer"
                v-else
              >
                <Empty
                  v-if="
                    data.bukti_transfer
                      ? data.bukti_transfer.length <= 0
                      : data.bukti_transfer
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h3 class="margin-remove">{{ item.tgl_tf }}</h3>
                      <a-button
                        @click="handleViewBt(item)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                    </div>
                    <img
                      class="m-image-icon"
                      slot="avatar"
                      :src="$serviceUrl + item.url"
                    />
                    <p slot="description" class="margin-remove m-list-title">
                      {{ formatCurrency(item.currency, item.value_tf) }}
                    </p>
                    <p slot="description" class="margin-remove">
                      {{ item.user_tf }}
                    </p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status=='Canceled' ? 'Cancelled' : data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.user_pembuat.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.header.tanggal_buat).format('DD-MM-YYYY HH:mm:ss')
                      }}
                    </h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                  :color="
                    workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                      ? 'red'
                      : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                  "
                >
                  <div class="m-timeline-title">
                    {{ workflow.job_desc }}
                    {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait ? data.dokumen_terkait : []"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(currency,item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-modal v-model="visibleUploadDoc" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="upload" />&nbsp;Upload Transaction Document </span>
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="uploadDoc.loading"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <b>Tanggal</b>
          </a-col><a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
            <a-input v-model="uploadDoc.tanggal" disabled></a-input>
          </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Description</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-textarea v-model="uploadDoc.deskripsi" disabled></a-textarea>
            </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Transaction Document</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-upload
                :showUploadList="true"
                :fileList="uploadDoc.doctransfiles"
                :beforeUpload="beforedoctransUpload"
                v-model="uploadDoc.file"
                :disabled="uploadDoc.loading"
              >
              <!-- :remove="handledoctransRemove" -->
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-col>
        </a-row>
      </a-spin> 
    </a-modal>

    <a-modal @ok="historyToggle" @cancel="modalOnClose" :footer="null" :maskClosable="false" width="80%">
      <span slot="title"> <a-icon type="plus" /> Add Data Tax Deposit Entry</span>

      <a-form :form="formTaxmodal">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Tax Date">
              <a-date-picker
                v-decorator="['tax_date', { rules: [{ required: true, message: 'please choose the date!' }], initialValue: edit_state ? edit_state.tax_date : null }]"
                placeholder="Select Date" format="DD-MM-YYYY" />
            </a-form-item>
            <a-form-item label="Tax Type">
              <a-select v-decorator="['tax_type', { rules: [{ required: true, message: 'please choose Tax Type!' }], initialValue: edit_state ? edit_state.type_tax : null }]"
              @change="changetaxType">
                <a-select-option v-for="item in getType_taxFiltered" :key="item.value" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Tax Deposit">
              <a-select
                v-decorator="['kode_setoran_pajak', { rules: [{ required: true, message: 'please choose Tax Deposit!' }], initialValue: edit_state ? edit_state.kode_setoran_pajak : null }]"
                option-filter-prop="children" :filter-option="filterOption" showSearch>
                <a-select-option v-for="item in data_tax.tax_deposit" :key="item.value" :value="item.value"
                  :text="item.text">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!-- <a-form-item label="Tax Object" v-if="!(datapajak.tax_type == 'pph_21' || datapajak.tax_type == 'ppn')"> -->

          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Tax Object" v-if="data_tax.tax_type !== 'pph_21' && data_tax.tax_type !== 'ppn'">
              <a-select v-decorator="['objek_pajak', { rules: [{ required: false }], initialValue: edit_state ? edit_state.kode_objek_pajak : null }]"
                option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                <a-select-option v-for="item in data_tax.object_tax" :key="item.value" :value="item.value" :text="item.text">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="DPP Value">
              <a-input-number type="number" class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'dpp_value',
                { rules: [{ required: true }], initialValue: edit_state ? edit_state.dpp_value : null },
              ]" />
            </a-form-item>

            <a-form-item label="Tax Value">
              <a-input-number type="number" class="m-width-full m-text-align-right"
                ref="taxvalue"
                v-on:keydown.enter.prevent="preventEnterButtontosave" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'value',
                {
                  rules: [{
                    required: true
                  }], initialValue: edit_state ? edit_state.value_tax : null
                },]" />
            </a-form-item>
            <!-- required: true, validator: (datapajak.jenis_transaksi && datapajak.jenis_transaksi.toLowerCase() == 'pi' ? checkPriceTaxValue : (datapajak.jenis_transaksi && datapajak.jenis_transaksi.toLowerCase() == 'rilis_pi' && datapajak.tax_type && datapajak.tax_type!='pph_2529' ? checkpiReleaseValue: checkPrice)) -->
          </a-col>
        </a-row>
        <a-button-group class="width-full">
          <a-button class="margin-top" :loading="loading_edit" @click="modalbuttonSavetaxDeposit" block type="primary" html-type="submit" ref="savetax"><b>Submit</b></a-button>
        </a-button-group>
      </a-form>
    </a-modal>

    <a-modal :visible="visibleTaxDeposite" @cancel="handleModalClose" :maskClosable="false" :width="'90%'">
      <span slot="title"> <a-icon type="reconciliation" />&nbsp;Verification Transaction Tax </span>
      <a-row :gutter="16">
        <!-- <a-col :xs="{ span: 24 }" :lg="{ span: expand.leftcolumn }"> -->
          <a-col :xs="{ span: 24 }">
          <a-spin :spinning="spinning_form" tip="Loading ...  ">
            <div class="container-dash">

              <a-form :form="formmodal">
                <div class="container-essential">
                  <a-row :gutter="12">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-form-item label="Detil transaction">
                        <a-select showSearch v-decorator="['id_dtl',
                          {
                            rules: [{ required: true }], initialValue: modalData.init_detil_transaction ? modalData.init_detil_transaction.id_dtl : null
                          },
                        ]" :disabled="true" class="select-between" @change="handle_DetilTransaction" ref="refid_dtl"
                          optionFilterProp="children" :filterOption="filterOptiondtl">
                          <a-select-option v-for="item in modalData.detil_transaction" :key="item.id_dtl"
                            :disabled="item.disabled">
                            <div style="display: flex;justify-content: space-between;opacity: 1;width: 100%;">
                              <span>[{{ moment(item.tgl, getStandartFormatDate).format(getDefaultDateFormat) }}] {{ item.deskripsi + ' ' }}</span>
                              <span style="float: right;"><b>{{ formatCurrency(item.currency, parseFloat(item.kredit)) }}</b></span>
                            </div>
                          </a-select-option>
                        </a-select>
                        <div v-if="modalData.init_detil_transaction && modalData.init_detil_transaction.potensial_tax" class="m-form-description-small">
                          <div style="width:100%;">
                            <span>
                              {{ modalData.init_detil_transaction ? modalData.init_detil_transaction.kredit : null }}
                            </span><br />
                            <div v-if="modalData.init_detil_transaction && modalData.init_detil_transaction.potensial_tax == '1'" class="lbltaxable">
                              {{ 'POTENTIALLY TAXABLE' }}</div>
                            <div v-else class="lblnottaxable">
                              {{ "IS'NT POTENTIALLY TAXABLE" }}
                            </div>
                          </div>
                        </div>

                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-form-item label="Verificator Note">
                        <a-textarea disabled :rows="4" v-model="modalData.init_detil_transaction.verificator_note" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>

                <div class="container-dash" style="margin-top:12px;margin-bottom:12px">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Value After Tax">
                        <a-radio-group button-style="solid" v-decorator="['is_vat', { rules: [{ required: true }], initialValue: '1' }]"
                          @change="handleChangeVat" ref="ref_is_vat" :disabled="modalData.anggaran.loadingtree">
                          <a-radio-button value="1">Yes</a-radio-button>
                          <a-radio-button value="0">No</a-radio-button>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Cost Center">
                        <a-select
                          :disabled="modalData.costcenter.length == 0 || isvat || modalData.anggaran.loadingtree"
                          showSearch v-decorator="[
                            'cost_center',
                            {
                              rules: [{ required: !isvat }],
                              initialValue: modalData.init_detil_transaction ? modalData.init_detil_transaction.anggaran_id : null,
                            },
                          ]" placeholder="Please Select Cost Center" @change="handleCost">
                          <a-select-option v-for="item in modalData.costcenter" :key="item.value">{{ item.text }}
                            ({{
                              item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                            }})</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Allotment">
                        <a-select
                          :disabled="modalData.peruntukan.length == 0 || isvat || modalData.anggaran.loadingtree"
                          showSearch v-decorator="[
                            'peruntukan',
                            {
                              rules: [{ required: !isvat }],
                              initialValue: dataEdit.peruntukan,
                            },
                          ]" placeholder="Please Select Allotment" @change="handle_Peruntukan" ref="refperuntukan"
                          optionFilterProp="children" :filterOption="filterOption">
                          <a-select-option v-for="item in modalData.peruntukan" :key="item.value">
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Budget Code">
                        <a-tree-select v-decorator="[
                          'kode_anggaran',
                          {
                            rules: [{ required: !isvat }],
                            initialValue: modalData.init_detil_transaction ? `${modalData.init_detil_transaction.peruntukan_id+';'+modalData.init_detil_transaction.anggaran_dtl_id+';'+modalData.init_detil_transaction.anggaran_dtl_val_id}` : null,
                          },
                        ]" show-search style="width: 100%" @select="handlechoiceCost"
                          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                          :tree-data="modalData.anggaran.tree" treeNodeFilterProp="children"
                          :filterTreeNode="filterTreeNode" placeholder="Please Select Budget Code"
                          :treeExpandedKeys="modalData.treeExpandedKeys" allow-clear :disabled="modalData.anggaran.loadingtree ||
                            modalData.anggaran.tree == undefined ||
                            modalData.anggaran.tree.length == 0 || isvat
                            " tree-default-expand-all>
                          <span slot="title" slot-scope="item">
                            <table style="width:100%">
                              <tr>
                                <td>
                                  <span>{{ item.texttitle }} -
                                    {{ item.kode_anggaran }}</span>
                                </td>
                                <td>
                                  <span style="float:right"><b>{{
                                    formatRupiah(parseFloat(item.rekap))
                                  }}</b></span>
                                </td>
                              </tr>
                            </table>
                          </span>
                          <template slot="suffixIcon"><a-icon :type="modalData.anggaran.loadingtree ? 'loading' : 'down'" />
                          </template>
                        </a-tree-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>

                <a-row :gutter="8">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <div class="container-dash">
                      <a-row :gutter="8">
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-form-item label="Tax Type">
                            <a-select v-decorator="[
                              'tax_type',
                              {
                                rules: [{ required: true }],
                                initialValue: modalData.type_pajak,
                              },
                            ]" show-search optionFilterProp="children" :filterOption="filterOption"
                              @change="handleChangeTaxType">
                              <a-select-option v-for="item in getType_taxFiltered" :key="item.value" :value="item.value">
                                {{ item.text }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                          <a-form-item label="Tax Deposit">
                            <a-select v-decorator="[
                              'kode_setoran_pajak',
                              {
                                rules: [{ required: true }],
                                initialValue: modalData.tax_deposit,
                              },
                            ]" option-filter-prop="children" :filter-option="filterOption" showSearch>
                              <a-select-option v-for="item in modalData.listsetoranpajak" :key="item.value"
                                :value="item.value" :text="item.text">
                                {{ item.text }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                          <a-form-item label="Tax Object" v-if="!(
                            modalData.reftax_type == 'pph_21' ||
                            modalData.reftax_type == 'ppn'
                          )
                            ">
                            <a-select v-decorator="[
                              'objek_pajak',
                              {
                                rules: [{ required: false }],
                                initialValue: modalData.tax_object,
                              },
                            ]" option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                              <a-select-option v-for="item in modalData.listobjekpajak" :key="item.value"
                                :value="item.value" :text="item.text">
                                {{ item.text }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                        </a-col>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-form-item label="DPP Value">
                            <a-input-number class="m-width-full m-text-align-right"
                              v-on:keydown.enter.prevent="preventEnterButton"
                              :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="['dpp_value',
                                {
                                  rules: [{ required: true, validator: checkPrice }],
                                  initialValue: modalData.dpp_value,
                                },
                              ]" />
                          </a-form-item>
                          <a-form-item label="Tax Value">
                            <a-input-number class="m-width-full m-text-align-right"
                              v-on:keydown.enter.prevent="preventEnterButton"
                              :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                                'tax_value',
                                {
                                  rules: [{ required: true, validator: checkPrice }],
                                  initialValue: modalData.tax_value,
                                },
                              ]" />
                          </a-form-item>
                          <a-form-item label="File Document Tax">
                            <a-upload :fileList="modalData.fileList" v-decorator="[
                              'file_document_tax',
                              {
                                rules: [
                                  { required: false, validator: doc_validation },
                                ],
                              },
                            ]" :remove="handleRemoveAttachment" :beforeUpload="beforeUploadAttachment">
                              <a-button> <a-icon type="upload" />Select File </a-button>
                            </a-upload>
                          </a-form-item>
                        </a-col>
                      </a-row>
                      <a-button v-if="modalData.state_modal == 'add'" type="primary" icon="disk"
                        @click="handleAddVarification" ref="addMainBtn" :loading="addVarification"
                        :disabled="modalData.anggaran.loadingtree" class="m-width-full margin-top">
                        Add
                      </a-button>
                      <a-row :gutter="8" v-else>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-button type="primary" @click="handleUpdateDetail" ref="addMainBtn"
                            :loading="addVarification" class="m-width-full margin-top"
                            :disabled="modalData.anggaran.loadingtree">
                            Change
                          </a-button>
                        </a-col>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-button type="danger" @click="handleCancelVarification" ref="addMainBtn"
                            class="m-width-full margin-top" :disabled="modalData.anggaran.loadingtree">
                            Cancel
                          </a-button>
                        </a-col>
                      </a-row>
                    </div>
                  </a-col>

                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-config-provider :locale="getLocalConfigProvider()">
                      <a-table bordered size="small" id="tbl_data_dtl" :rowKey="(record, index) => { return index; }"
                        :columns="table.verificationdtl" :dataSource="data_verif_dtl"
                        :pagination="paginationverificationdtl" :scroll="{ x: 835 }"
                        :rowClassName="(record, index) => { return record.id == modalData.id_tax_verif_trans ? 'selectedRow' : '' }">
                        <template slot="title">
                          List Details
                        </template>
                        <template slot="nomor" slot-scope="text, data,index">
                          <div class="m-text-align right">{{ index + 1 }}</div>
                        </template>
                        <template slot="detail" slot-scope="data">
                          {{ data.detail }}
                        </template>
                        <template slot="no_trans" slot-scope="data">
                          {{ data.no_trans }}
                        </template>
                        <template slot="type_tax" slot-scope="data">
                          <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
                        </template>
                        <template slot="dpp_value" slot-scope="data">
                          <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
                        </template>
                        <template slot="tax_value" slot-scope="data">
                          <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
                        </template>
                        <template slot="action" slot-scope="text,data,index">
                          <a-button-group>
                            <a-button type="primary" @click="editdtl(data)" icon="edit" size="small"
                              :disabled="modalData.state_modal == 'edit'">
                            </a-button>
                            <a-button type="danger" @click="deletedtl(data.id)" icon="close" size="small"
                              :disabled="modalData.state_modal == 'edit'" :loading="deleteVarification && data.id == modalProcessKey">
                            </a-button>
                          </a-button-group>
                        </template>
                      </a-table>
                    </a-config-provider>
                  </a-col>

                </a-row>
              </a-form>

            </div>
          </a-spin>
        </a-col>

        <!-- <a-col :xs="{ span: 24 }" :lg="{ span: expand.rightcolumn }">
          <div class="container-headertable">
            <div class="m-display-flex space-between align-middle">
              <span>List Details</span>
            </div>
          </div>
          <a-config-provider :locale="getLocalConfigProvider()">
            <a-table bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
              :columns="columns.verificationdtl" :dataSource="verificationdtl_source"
              :pagination="paginationverificationdtl" :scroll="{ x: 835 }">
              <template slot="title">
                <a-input-search v-decorator="['searchListDtl', { rules: [{ required: false }] }]"
                  @change="searchingListDtl" placeholder="Quick Search" />
              </template>
              <template slot="nomor" slot-scope="text, data,index">
                <div class="m-text-align right">{{ index + 1 }}</div>
              </template>
              <template slot="detail" slot-scope="data">
                <div class="m-text-align left">{{ data.detail }}</div>
                <small v-if="data.kode_anggaran"><i>[{{ data.kode_anggaran + "-" + data.item_anggaran }}]</i></small>
              </template>
              <template slot="notrans" slot-scope="data">
                <div class="m-text-align center">{{ data.no_trans }}</div>
              </template>
              <template slot="dttrans" slot-scope="data">
                <div class="m-text-align center">{{ moment(data.tgl, getStandartFormatDate).format(getDefaultDateFormat)
                }}</div>
              </template>
              <template slot="price" slot-scope="data">
                <div class="m-text-align center">{{ formatCurrency('IDR', data.harga) }}</div>
              </template>
              <template slot="pttax" slot-scope="data">
                <div class="m-text-align center">{{ data.potensial_tax && data.potensial_tax == "1" ? "Yes" : "No" }}
                </div>
              </template>
              <template slot="type" slot-scope="data">
                <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
              </template>
              <template slot="dppvalue" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
              </template>
              <template slot="value" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
              </template>
              <template slot="action" slot-scope="text,data,index">
                <div :class="loading.loadJenis == 'view' ? 'm-text-align center' : 'm-text-align right'">
                  <a-button-group>
                    <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                      <a-button
                        :disabled="data.tax_document_name == '' || data.tax_document_name == null || loading.spinform"
                        type="default" @click="viewFiledtl(data.tax_document_name, data.tax_document_path)" icon="file"
                        size="small">
                      </a-button>
                    </a-tooltip>
                    <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="Edit Row">
                      <a-button v-if="loading.loadJenis != 'view'" type="primary" @click="editdtl(data.id)" icon="edit"
                        size="small" :loading="loading.spinform && data.id == modalData.id_tax_verif_trans"
                        :disabled="loading.spinform || modalData.id_tax_verif_trans != ''">
                      </a-button>
                    </a-tooltip>
                  </a-button-group>
                </div>
              </template>
            </a-table>
          </a-config-provider>
        </a-col> -->
      </a-row>
      <!-- v-if="loading.loadJenis != 'view'" -->
      <div slot="footer">
        <a-button @click="handleModalClose" type="danger"
          :disabled="modalData.anggaran.loadingtree">
          Return to Manifest</a-button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";

export default {
  name: "ManifestKlaimPp",
  components: { Status },
  props: ["id", "tlc", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {

    let doc_validation = (rule, value, callback) => {
      if (this.modalData.fileList && this.modalData.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };

    const table = {
      verificationdtl: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        // {
        //   title: "Transaction Date",
        //   key: "tgl",
        //   scopedSlots: { customRender: "tgl_trans" },
        //   width: 150,
        // },
        // {
        //   title: "Detil transaction",
        //   key: "detail",
        //   scopedSlots: { customRender: "detail" },
        //   width: 230,
        // },
        // {
        //   title: "Price",
        //   key: "harga",
        //   scopedSlots: { customRender: "harga" },
        //   width: 150,
        // },
        // {
        //   title: "Potential Tax",
        //   key: "potensial_tax",
        //   scopedSlots: { customRender: "potensial_tax" },
        //   width: 150,
        // },
        {
          title: "No.Verification",
          key: "no_trans",
          scopedSlots: { customRender: "no_trans" },
          width: 150,
        },
        {
          title: "Type tax",
          key: "type_tax",
          scopedSlots: { customRender: "type_tax" },
          width: 150,
        },
        {
          title: "DPP Value",
          key: "dpp_value",
          scopedSlots: { customRender: "dpp_value" },
          width: 150,
        },
        {
          title: "Tax Value",
          key: "tax_value",
          scopedSlots: { customRender: "tax_value" },
          width: 150,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 85,
        },
      ],
    };

    return {
      currency:"",
      previewVisible: false,
      previewImage: "",
      visibleHistory: false,
      pageLoading: true,
      saveLoading: false,
      disabled: true,
      data: {},
      push: [],
      isRevised: false,
      doc_validation,
      table,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      printLoad: {
        manifest: false,
        manifestkomisi: false,
        cancel: false,
        manifestfiktif: false,
        manifestWtNote: false,
      },
      checkTransferValue: true,
      visibleUploadDoc: false,
      uploadDoc: {
        file: null,
        doctransfiles: null,
        id_dtl_trans: null,
        tanggal: null,
        deskripsi: null,
        loading: false,
        loading2: false,
        loading2key: "",
      },
      visibleTaxDeposite: false,
      edit_state: null,
      data_tax: {
        object_tax: {},
        tax_deposit: {},
        raw_tax_deposit: {},
        tax_type: null
      },
      loading_edit: false,
      dataEdit: [],
      modalProcess: false,
      modalData: {
        id_tax_verif_trans: "",
        costcenter: [],
        costcenterOri: [],
        jenis_anggaran: [],
        kode_anggaran: [],
        kode_anggaranOri: [],
        peruntukan: [],
        peruntukanOri: [],
        sub_peruntukan: [],
        sub_peruntukanOri: [],
        treeExpandedKeys: [],
        detil_transaction: [],
        init_detil_transaction: {},
        anggaran: {
          tree: [],
          loadingtree: false,
        },
        listsetoranpajak: [],
        listsetoranpajakOri: [],
        listobjekpajak: [],
        fileList: [],
        dtl_value: "",
        state_modal: 'add'
      },
      isvat: true,
      pageLoading: false,
      loading: false,
      data_verif_dtl: [],
      paginationverificationdtl: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      verificationdtl_source: [],
      verificationdtl_sourceOri: [],
      addVarification: false,
      deleteVarification: false,
      spinning_form: false,
      modalProcessKey: "",
      jns_transaksi: ""
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formTaxmodal = this.$form.createForm(this);
    this.formmodal = this.$form.createForm(this);

  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("handleCancel", this.canceltrans);
  },
  created() {
    this.fetchManifest();
    this.$store.dispatch("Fetch_TYPE_TAX");

    if (!this.getScreen) {
      this.getDetailPemakaianWeb();
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.push = [];
        this.checkTransferValue = true;
        this.disabled = true;
        this.search = "";
        this.isRevised = false;
      }

      if (!this.getScreen) {
        this.getDetailPemakaianWeb();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getType_tax"
    ]),

    isTaxOfficer() {
      let data = _.filter(this.getAuth.nama_bidang, (obj) => obj == "Tax Officer");
      return data.length > 0 ? true : false;
    },

    getType_taxFiltered(){
      return this.getType_tax.filter((obj)=> obj.value!='bea_masuk')
    },

    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 100,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Description",
          key: "deskripsi",
          width: 200,
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
          scopedSlots: { customRender: "deskripsi" },
        },
        {
          title: "PP Detail",
          key: "item_anggaran",
          width: 200,
          sorter: (a, b) => a.item_anggaran.length - b.item_anggaran.length,
          scopedSlots: { customRender: "item_anggaran" },
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Credit",
          dataIndex: "kredit",
          key: "kredit",
          width: 100,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
          scopedSlots: { customRender: "kredit" },
        },
      ];

      if(this.isTaxOfficer){
        kolom.push({
          title: "Tax Deposit",
          key: "doc_tax",
          fixed: "right",
          scopedSlots: { customRender: "doc_tax" },
          width: 100,
        },);
      }

      return kolom;
    },

    searching() {
      if (this.search) {
        this.tableData = this.tableDataTemp;
        this.tableData = this.tableData.filter(
          (obj) =>
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            moment(obj.tanggal, "DD-MM-YYYY")
              .format("DD-MM-YYYY")
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_biaya_pp",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.id = response.data.invoice[0].id_klaim;
          this.currency = response.data.invoice[0].currency;
          this.data = {
            status_transfer: response.data.status_transfer,
            header: {
              no_pp: response.data.invoice[0].no_pp,
              no_klaim: response.data.invoice[0].no_klaim,
              tanggal_buat: response.data.invoice[0].tanggal,

              user_pelapor: response.data.invoice[0].nama,
              total_klaim: response.data.invoice[0].total_klaim || 0,
              kode_project: response.data.invoice[0].kode_project,
              catatan: response.data.invoice[0].catatan,
            },
            jenis: response.data.jenis,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].tgl_buat,

              status: "Created",
            },
            sisa_tf: response.data.sisa_tf,
            aksi: response.data.aksi,
            bukti_transfer: response.data.detail_bukti_transfer,
            detail_invoice: response.data.dtl_invoice,
            dokumen_terkait: response.data.dokumen_terkait,
            status: response.data.status_app,
            history: response.data.notifikasi,
            iskomisi: response.data.iskomisi,
          };

          this.data_tax.object_tax = response.data.objek
          this.data_tax.tax_deposit = response.data.setoran
          this.data_tax.raw_tax_deposit = response.data.setoran

          if (!this.getScreen) {
            let dataPemakaian = response.data.dtl_invoice;

            response.data.dtl_invoice.forEach((value, index) => {
              dataPemakaian[index]["kredit"] = {
                curr: value.currency,
                val: Number(value.nilai),
              };
              dataPemakaian[index]["no"] = index + 1;
              dataPemakaian[index]["key"] = index + 1;
              dataPemakaian[index]["tanggal"] = moment(value.tanggal).format(
                this.getDefaultDateFormat
              );
            });

            this.tableData = dataPemakaian;
            this.tableDataTemp = dataPemakaian;
          }

          this.pageLoading = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint(item) {
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_biaya_pp/cetak_laporan_klaim",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_klaim: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlePrintKomisi(item) {
      this.printLoad.manifestkomisi = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_biaya_pp/cetak_laporan_klaim_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_klaim: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
          this.printLoad.manifestkomisi = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.printLoad.manifestkomisi = false;
          this.$router.go(-1);
        });
    },
    handlePrintFiktif() {
      this.printLoad.manifestfiktif = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_biaya_pp/cetak_laporan_klaim_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_klaim: this.id,
          fiktif:"1",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestfiktif = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestfiktif = false;
          this.$router.go(-1);
        });
    },
    handlePrintWtNote() {
      this.printLoad.manifestWtNote = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_biaya_pp/cetak_laporan_klaim_tanpa_nota",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_klaim: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestWtNote = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestWtNote = false;
          this.$router.go(-1);
        });
    },
    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.confirmMessage("confirm-save");
      });
    },
    handleActionProcess() {
      this.saveLoading = true;
      if (this.data.jenis.toLowerCase() === "transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          let post = new FormData();
          post.append("id_klaim", this.id);
          post.append("tlc", this.getAuth.username);
          post.append("status", values.status);
          post.append("remark", values.remark);
          post.append(
            "tgl_tf",
            moment(values.tgl_trf).format(this.getStandartFormatDate)
          );
          post.append("value_transferan", values.value_transferan);
          post.append("file_transfer", this.push[0]);

          axios({
            method: "post",
            url: this.$serviceUrl + "klaim_biaya_pp/approval ",
            processData: false,
            data: post,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.saveLoading = false;
              this.$router.go();
            })
            .catch((err) => {
              this.saveLoading = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "klaim_biaya_pp/approval ",
            processData: false,
            data: {
              id_klaim: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan ? values.catatan : "",
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.saveLoading = false;
              this.$router.go();
            })
            .catch((err) => {
              this.saveLoading = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            });
        });
      }
    },
    handleCheckData(e) {
      if (e.target.checked) {
        this.disabled = true;
        this.checkTransferValue = true;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf,
        });
      } else {
        this.disabled = false;
        this.checkTransferValue = false;
        this.form.setFieldsValue({
          value_transferan: 0,
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    removeFileList() {
      this.push = [];
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewBt(file) {
      console.log(file);
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(this.$serviceUrl + file.url, "_blank");
      } else {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      }
    },
    handleAksi(e) {
      if (e == "Revised") {
        this.isRevised = true;
        this.disabled = false;
        this.push = [];
      } else {
        this.disabled = true;
        this.isRevised = false;
      }
    },

    getDetailPemakaianWeb() {
      // axios({
      //     method: "get",
      //     url: this.$serviceUrl + "klaim_biaya_pd/web_detil_pemakaian",
      //     params: {
      //         id: this.id
      //     },
      //     auth: {
      //         username: this.getAuth.username,
      //         password: this.getAuth.password
      //     },
      //     headers: {
      //         "X-API-KEY": this.getAuth.apikey
      //     }
      // })
      //     .then(response => {
      //         let dataPemakaian = response.data.detail_pemakaian;
      //         response.data.detail_pemakaian.forEach((value,index)=>{
      //             if(value.debit !== '-'){
      //                 dataPemakaian[index]['debit'] = this.formatCurrency(value.currency,value.debit);
      //             }
      //             if(value.kredit !== '-'){
      //                 dataPemakaian[index]['kredit'] = this.formatCurrency(value.currency,value.kredit);
      //             }
      //             dataPemakaian[index]['sisa'] = this.formatCurrency(value.currency,value.sisa);
      //             dataPemakaian[index]['tanggal'] = moment(value.tanggal).format(this.getDefaultDateFormat);
      //         })
      //         this.tableData =  dataPemakaian;
      //         this.tableDataTemp =  dataPemakaian;
      //     })
      //     .catch(err => {
      //         if (err.response.status === 404) {
      //             this.$notification.error({
      //                 message: "Oops..",
      //                 description: "Alien sedang menyerang 😆"
      //             });
      //         }
      //         this.pageLoading = false;
      //         this.$router.go(-1);
      //     });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "klaim_cc_pp",
        id_manifest: this.id,
        code_trans: this.data.header.no_sppd,
        kode_project: this.data.header.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "klaimPpEdit",
        params: { id: this.id, type: "revised" },
      });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleUploadDoc(item) {
      this.uploadDoc.tanggal = item.tanggal;
      this.uploadDoc.deskripsi = item.deskripsi;
      this.uploadDoc.id_dtl_trans = item.id_dtl;
      this.uploadDoc.doctransfiles = [];

      if (item.lampiran) {
        this.uploadDoc.loading2 = true;
        this.uploadDoc.loading2key = item.id_dtl;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
          .then((response) => {
            let typefile = this.fileTypeFromUrl(item.lampiran);
            let file = this.dataURLtoFile(
              typefile + response.file_document_tax,
              item.lampiran
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + item.lampiran_path;
            this.uploadDoc.doctransfiles = [];
            this.uploadDoc.doctransfiles.push(file);

            this.uploadDoc.loading2 = false;
            this.uploadDoc.loading2key = "";
            this.visibleUploadDoc = true;
          })
          .catch((err) => {
            this.uploadDoc.loading2 = false;
            this.uploadDoc.loading2key = "";
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.visibleUploadDoc = true;
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let data = new FormData();
        data.append("tipe_trans", "klaim_pp");
        data.append("id_dtl_trans", this.uploadDoc.id_dtl_trans);
        data.append("file_upload", file);

        this.uploadDoc.loading = true;
        this.asyncAxiosPost("main/upload_lampiran", "formdata", this.getAuth, data)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.uploadDoc.loading = false;
            this.fetchManifest();
            this.visibleUploadDoc = false;
          })
          .catch((err) => {
            console.log(err);
            this.uploadDoc.loading = false;
            if (err.response && err.response.data) {
              this.$notification.error({
                message: "Error Message",
                description: err.response.data.message,
              });
            } else {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            }
          });
        this.uploadDoc.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.uploadDoc.doctransfiles = [];
    },

    // handleShowTaxModal(params){
    //   this.data_tax.tax_type = params.type_tax;
    //   this.visibleTaxDeposite = true
    //   this.edit_state = params
    // },

    changetaxType(val){
      this.data_tax.tax_deposit = this.data_tax.raw_tax_deposit.filter((obj)=> obj.id_type_tax == val);
      this.data_tax.tax_type = val;
      this.$nextTick(function () {
        this.formTaxmodal.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    modalbuttonSavetaxDeposit(params){
      console.log(this.edit_state);
      this.loading_edit = true
      this.formTaxmodal.validateFields((err, values) => {
        if (err) {
          this.loading_edit = false
          this.displayMessage("form-warning");
          return;
        }
        
        const payload = {
          tax_date: moment(values.tax_date).format(this.getStandartFormatDate),
          tax_type: values.tax_type,
          jenis_transaksi: "klaim_pp",
          id_header: this.edit_state.id_hdr,
          id_dtl: this.edit_state.id_dtl,
          kode_setoran_pajak: values.kode_setoran_pajak,
          objek_pajak: values.objek_pajak,
          value: values.value,
          dpp_value: values.dpp_value
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "main/setoran_pajak ",
          processData: false,
          data: payload,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((res) => {
          this.fetchManifest()
          this.getDetailPemakaianWeb()
          this.loading_edit = false
          this.visibleTaxDeposite = false
          this.formTaxmodal.resetFields();

          this.displayMessage("success");
        }).catch((err) => {
          console.log(err);
          this.displayMessage("error");
        })
        
      })
    },

    modalOnClose(){
      this.edit_state = null
      this.formTaxmodal.resetFields();
      this.visibleTaxDeposite = false
    },

    historyToggle(e) {
      e.stopPropagation();
    },

    handleShowTaxModal(params){
      this.fetchDetailTax(params)
      this.data_tax.tax_type = params.type_tax;
      this.visibleTaxDeposite = true
      this.edit_state = params
    },

    handle_DetilTransaction(val){
      console.log(val);
    },

    filterOptiondtl(val){
      console.log(val);
      
    },

    async handleChangeVat(val){
      if (val.target.value == "1") {
        this.isvat = true;
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            kode_anggaran: null,
          });
        });
      } else if (val.target.value == "0") {
        this.isvat = false;
        let anggaran_id = this.modalData.init_detil_transaction.anggaran_id;
        let id_dtl = this.modalData.init_detil_transaction.id_dtl;
        if (!anggaran_id) {
          return
        }

        let dataFiltered = _.filter(this.modalData.peruntukanOri, (el) => el.anggaran_id == anggaran_id);
        this.modalData.peruntukan = dataFiltered

        try {
          await this.handle_DetilTransaction2(id_dtl, val.target.value);
        } catch(err) {
          console.log(err);
        }
      }
    },

    handleCost(e){
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.modalData.subPeruntukan = [];
      const peruntukan = this.modalData.peruntukanOri.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.modalData.peruntukan = peruntukan;
    },

    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },

    async handle_Peruntukan(e){
      try {
        let anggId = this.formmodal.getFieldValue("cost_center")
        if (anggId) {
          this.modalData.anggaran.loadingtree = true
          this.$nextTick(function () {
            this.formmodal.setFieldsValue({
              kode_anggaran: null,
            });
          });

          const res = await this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
            anggaran_id: anggId,
            peruntukan_id: e,
          })

          this.modalData.anggaran.tree = res.tree;
          this.modalData.treeExpandedKeys = this.getParent(
            this.modalData.anggaran.tree
          );
          this.modalData.anggaran.loadingtree = false;
 
        } else {
          this.displayMessageValue("error-other", "Cost Center Must be selected first!");
        }
      } catch (error) {
        this.modalData.anggaran.loadingtree = false;
        let responses = Object.assign({}, error.response.data);
        this.displayMessageValue("error-other", responses.message);
      }
    },

    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    handlechoiceCost(val){
      console.log(val);
      
    },

    handleChangeTaxType(e) {
      this.modalData.reftax_type = e;
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
      this.filtertaxDeposit(e);
    },

    filtertaxDeposit(val) {
      this.modalData.listsetoranpajak = _.filter(this.modalData.listsetoranpajakOri, (item) => item.id_type_tax == val);
    },

    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },

    handleRemoveAttachment() {
      this.modalData.fileList = [];
    },

    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalData.fileList = [];
        this.modalData.fileList.push(file);
        return false;
      }
    },

    handleAddVarification(){
      this.addVarification = true;
      this.formmodal.validateFields( async (err, values) => {
        if (err) {
          this.addVarification = false;
          this.displayMessage("form-warning");
          return;
        }

        let payload = new FormData()
        try {
          payload.append('tax_type', values.tax_type)
          payload.append('tax_deposit', values.kode_setoran_pajak)
          payload.append('dpp_value', values.dpp_value)
          payload.append('tax_value', values.tax_value)
          payload.append('jenis_transaksi', this.jns_transaksi)
          payload.append('id_header', this.modalData.init_detil_transaction.id_header)
          payload.append('id_dtl', this.modalData.init_detil_transaction.id_dtl)
          payload.append('description', this.modalData.init_detil_transaction.deskripsi)
          
          if(values.tax_type !== 'ppn' && values.tax_type !== 'pph_21') {
            payload.append('tax_object', values.objek_pajak ? values.objek_pajak : null)
          }
          if(values.is_vat !== '1'){
            let array_code = values.kode_anggaran.split(';');            
            payload.append('kode_anggaran', array_code[2])
          }
          if (this.modalData.fileList.length > 0)
          payload.append("file_document_tax", this.modalData.fileList[0]);

          const res = await axios({
            method: "post",
            url: this.$serviceUrl + "Tax_verification/tax_detil",
            processData: false,
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })

          if(res){
            this.displayMessage("success-save");
            this.data_verif_dtl = res.data.list_tax_dtl
            this.clearForm()
          }
          this.addVarification = false;
        } catch (error) {
          console.log(error);
          this.addVarification = false;
        }
      });
    },

    handleCancelVarification(){
      this.clearForm()
      this.modalData.state_modal = 'add'
    },

    async fetchDetailTax(val){
      this.spinning_form = true
      try {
        const response = await axios({
          method: "get",
          url: this.$serviceUrl + "tax_verification/tax_detil",
          params: {
            jenis_transaksi: "klaim_pp",
            id_header: this.id,
            id_dtl: val.id_dtl,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })

        this.modalData.detil_transaction = response.data.detil_transaction
        this.modalData.init_detil_transaction = response.data.detil_transaction[0]
        this.modalData.costcenter = response.data.cost_center
        this.modalData.peruntukan = response.data.peruntukan
        this.modalData.peruntukanOri = response.data.peruntukan
        this.modalData.listsetoranpajak = response.data.setoran
        this.modalData.listsetoranpajakOri = response.data.setoran
        this.modalData.listobjekpajak = response.data.objek
        this.data_verif_dtl = response.data.list_tax_dtl
        this.jns_transaksi = response.data.jenis_transaksi

        if (response.data.list_tax_dtl) {
          this.verificationdtl_source = response.data.list_tax_dtl;
          for (let x = 0; x < this.verificationdtl_source.length; x++) {
            if (this.verificationdtl_source[x].id == undefined)
              this.verificationdtl_source[x].id = this.verificationdtl_source[x].id_dtl;
          }
          this.verificationdtl_sourceOri = this.verificationdtl_source
        }
        this.spinning_form = false
        
      } catch (error) {
        console.log(error);
        this.spinning_form = false
      }
    },
    
    async handle_DetilTransaction2(e, isvat) {
      if (isvat !== "0") return 
      try {
        this.modalData.anggaran.loadingtree = true;
        let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == e);

        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            cost_center: params[0].anggaran_id,
            peruntukan: params[0].peruntukan_id,
          });
        });

        const res = await this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
          anggaran_id: params[0].anggaran_id,
          peruntukan_id: params[0].peruntukan_id,
        })

        this.modalData.anggaran.tree = res.tree;
        this.modalData.treeExpandedKeys = this.getParent(
          this.modalData.anggaran.tree
        );
        this.modalData.anggaran.loadingtree = false;

      } catch (error) {
        console.log(error);
        
        this.modalData.anggaran.loadingtree = false;
        let responses = Object.assign({}, error.response.data);
        this.displayMessageValue("error-other", responses.message);
      }
    },

    gettitletax(val) {
      let res = this.getType_tax.filter((el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },

    deletedtl(id) {
      const that = this;
      that.deleteVarification = true;
      that.modalProcessKey = id;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.deleteVarification = true;
          that.modalProcessKey = id;

          that.asyncAxiosDelete(
            "Tax_verification",
            "application/json",
            that.getAuth,
            { id: id }
          ).then(() => {
            that.deleteVarification = false;
            that.modalProcessKey = "";
            let newData = that.data_verif_dtl.filter((d) => d.id !== id);
            that.data_verif_dtl = newData
            that.displayMessage("success-del");
          }).catch((err) => {
            console.log(err);
            that.deleteVarification = false;
            that.modalProcessKey = "";
          });
        },
        onCancel() {
          that.deleteVarification = false;
          that.modalProcessKey = "";
        },
      })
    },

    returnToList(){
      this.visibleTaxDeposite = false
      this.clearForm()
    },

    handleModalClose(){
      this.fetchManifest()
      this.modalData.detil_transaction = []
      this.visibleTaxDeposite = false
      this.clearForm()
      this.modalData.reftax_type = null
      this.modalData.state_modal = 'add'
    },

    clearForm(){
      this.formmodal.setFieldsValue({
        tax_type: null,
        kode_setoran_pajak: null,
        objek_pajak: null,
        dpp_value: null,
        tax_value: null,
        is_vat: '1'
      });
      this.modalData.fileList = []
      this.isvat = true
      this.modalData.reftax_type = ""
      this.modalData.anggaran.tree = null;
    },

    async editdtl(val){
      console.log(val);
      this.edit_state = val
      this.spinning_form = true

      this.modalData.state_modal = 'edit'
      this.modalData.reftax_type = val.tax_type
      this.formmodal.setFieldsValue({
        tax_type: val.tax_type,
        kode_setoran_pajak: val.tax_deposit_id,
        dpp_value: val.dpp_value,
        tax_value: val.tax_value,
        is_vat: val.id_anggaran !== null ? '0' : '1',
        kode_anggaran: val.id_anggaran
      });

      if(val.tax_object_id !== null){
        this.formmodal.setFieldsValue({
          objek_pajak: val.tax_object_id
        });
      }
      
      if(val.id_anggaran !== null){
        this.isvat = false;
        let anggaran_id = this.modalData.init_detil_transaction.anggaran_id;
        let id_dtl = this.modalData.init_detil_transaction.id_dtl;
        if (!anggaran_id) {
          return
        }
      
        try {
          this.modalData.peruntukan = _.filter(this.modalData.peruntukanOri, (el) => el.anggaran_id == anggaran_id);
          await this.handle_DetilTransaction2(id_dtl, '0');
        } catch(err) {
          console.log(err);
          this.spinning_form = false;
        } 
        finally {
          this.spinning_form = false;
        }
      }else {
        this.isvat = true;
        setTimeout(() => {
          this.spinning_form = false
        }, 500)
      }
    },

    handleUpdateDetail(){
      this.formmodal.validateFields( async (err, values) => {
        if(err){
          this.displayMessage("form-warning");
          return;
        }

        let payload = new FormData()
        try {
          payload.append('id', this.edit_state.id)
          payload.append('tax_type', values.tax_type)
          payload.append('tax_deposit', values.kode_setoran_pajak)
          payload.append('dpp_value', values.dpp_value)
          payload.append('tax_value', values.tax_value)
          payload.append('jenis_transaksi', this.jns_transaksi)
          payload.append('id_header', this.modalData.init_detil_transaction.id_header)
          payload.append('id_dtl', this.modalData.init_detil_transaction.id_dtl)
          payload.append('description', this.modalData.init_detil_transaction.deskripsi)
          
          if(values.tax_type !== 'ppn' && values.tax_type !== 'pph_21') {
            payload.append('tax_object', values.objek_pajak)
          }
          if(values.is_vat !== '1'){
            let array_code = values.kode_anggaran.split(';');            
            payload.append('kode_anggaran', array_code[2])
          }
          if (this.modalData.fileList.length > 0)
          payload.append("file_document_tax", this.modalData.fileList[0]);

          const res = await axios({
            method: "post",
            url: this.$serviceUrl + "Tax_verification/tax_detil_edit",
            processData: false,
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })

          if(res){
            this.displayMessage("success-edit");
            this.data_verif_dtl = res.data.list_tax_dtl
            this.clearForm()
          }
          this.addVarification = false;
          this.modalData.state_modal = 'add'
        } catch (error) {
          console.log(error);
          this.addVarification = false;
        }
        
      })
    }

  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("handleCancel", this.canceltrans);
  },
};
</script>

<style scoped lang="less">
.m-image-icon {
  width: 50px;
}
</style>